import React from 'react';
import Slider from 'react-slick';
import { graphql } from 'react-apollo/index';
import CONFIGURATIONS_QUERY from '../../../graphql/Configurations';

class Slideshow extends React.PureComponent {
  render() {
    const { loading, configurations, title } = this.props;
    let images = [];
    if (!loading) {
      const slideshow = configurations.find(c => c.key === 'main_slideshow');
      images = slideshow.value;
    }

    const settings = {
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    return (
      <div className="slideshow-wrapper">
        {title && (
          <h1 className="slideshow-title">{title}</h1>
        )}
        <Slider {...settings}>
          {images.map(v =>
            (<div
              key={v}
              style={{
                backgroundImage: `url(${v})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                minHeight: 450,
              }}
            />))}
        </Slider>
      </div>
    );
  }
}

const withConfig = graphql(CONFIGURATIONS_QUERY, {
  options: () => ({
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data }) => ({
    loading: data.loading,
    configurations: data.getConfigs,
  }),
});

export default withConfig(Slideshow);



// WEBPACK FOOTER //
// ./src/containers/Others/Slideshow/index.js